import React from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Table,
} from 'reactstrap';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { renderStatusColors } from '../../../pages/HRTravelRequest/BookingAgent/constants';
import { Badge } from '../../Common';
import { travelRequestHeaders } from './constants';
import './CloneRequestModal.scss';
import { cloneTravelRequest } from '../../../store/apis/travelService';
import { Messages } from '../../../common/messages';

function CloneRequestModal({ isOpen, toggle }) {
  const navigate = useNavigate();
  const { data: cloneTravelReqData, isLoading } = useQuery({
    queryKey: ['cloneTravelReqData'],
    queryFn: () => cloneTravelRequest({ type: 'CLONE' }),
  });

  const renderTableBody = () => {
    const tableData = cloneTravelReqData;

    if (!tableData || tableData.length === 0) {
      return (
        <tr>
          <td className="text-center" colSpan={9}>
            {isLoading ? (
              <>
                <Spinner color="dark" size="sm" />
                <span className="ms-2">Loading...</span>
              </>
            ) : (
              Messages.NO_CLONE_REQUESTS
            )}
          </td>
        </tr>
      );
    }

    return tableData.map(item => (
      <tr key={item?.RequestNo}>
        <td>
          <button
            type="button"
            className="btn btn-link text-decoration-underline p-0"
            onClick={() => {
              navigate(
                `/travel-request/edit/${item?.RequestNo}/${item?.RevisionNo}?m=Clone`,
              );
              toggle();
            }}
          >
            {item?.RequestNo}
          </button>
        </td>
        <td>{moment(item?.TravelDate).format('L')}</td>
        <td>{item?.TravelDestination}</td>
        <td
          style={{
            maxWidth: '450px',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {item?.TravelPurpouse}
        </td>
        <td>
          <Badge config={renderStatusColors[item.Status]} labelType="TitleCase">
            {item.Status}
          </Badge>
        </td>
      </tr>
    ));
  };
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className="clone-request-modal"
      size="xl"
      centered
    >
      <ModalHeader toggle={toggle} className="pb-3">
        Clone Travel Request
      </ModalHeader>
      <ModalBody className="">
        <div
          className="table-responsive clone-request-table"
          style={{
            border: '2px solid #D0D5DD',
            borderRadius: '8px',
          }}
        >
          <Table className="custom-table">
            <thead>
              <tr>
                {travelRequestHeaders.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </Table>
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="custom-btn" onClick={toggle}>
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default CloneRequestModal;
